module.exports = __webpack_public_path__ + "static/img/e6.d53886b8.png";